import { useMemo } from 'react'
import { Box } from '@mui/material'
import { SORTablePropsInterface } from './SOR.types'
import { SORColumns } from './SORTableColumns'
import { BaseTable } from 'Features/Table/BaseTable.view'
import { ExtendedGridColDef } from 'Features/Table/BulkUpdateModal'

export const SORTable = <T extends Record<string, unknown>>({
  data,
  isLoading,
  updateTableData,
  uploadScheduleData,
  isUploading,
  isSaving,
  updateRowsStatus,
  predicate,
  dataConfig,
  API,
  onDeleteRows,
  isDeleting,
}: SORTablePropsInterface<T>) => {
  // Handle data updates for BaseTable
  const handleDataUpdate = (changedRows: Record<number, T>) => {
    updateTableData(changedRows)
  }

  const columns: ExtendedGridColDef[] = useMemo(
    () =>
      typeof SORColumns[API as keyof typeof SORColumns] === 'function'
        ? SORColumns[API as keyof typeof SORColumns](data).map((col) => {
            //All the columns are editable except the ones specified in the predicate
            col.editable = !predicate?.includes(col.field)
            return col
          })
        : [],
    [data, predicate]
  )

  return (
    <Box>
      <BaseTable
        data={data ?? []}
        columns={columns}
        isLoading={isLoading}
        updateTableData={handleDataUpdate}
        uploadData={uploadScheduleData}
        isUploading={isUploading}
        isSaving={isSaving}
        checkBoxSelection={true}
        showTableToolBar={true}
        downloadFileName={API}
        onDeleteRows={onDeleteRows}
        isDeleting={isDeleting}
        multiStageUpload={{
          uploadFile: uploadScheduleData,
          isUploading: isUploading,
          columns: columns,
          updateRowsStatus: updateRowsStatus,
          originalData: data,
          predicate: predicate,
          dataConfig: dataConfig,
        }}
        initialState={{
          pagination: { paginationModel: { pageSize: 100 } },
        }}
        sx={{
          maxWidth: 'calc(100vw - 70px)',
          '& .MuiDataGrid-cell--editable': {
            backgroundColor: '#CBD5E1',
          },
          '& .MuiBox-root': {
            padding: '0px !important',
          },
        }}
      />
    </Box>
  )
}
